var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewIconBadOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 17.4339C9.1213 16.2339 6.25 15.9125 5.25 15.6625V6.4728C6.18542 6.4728 7.24056 6.20175 10.7827 5.29071C13.4982 4.59229 15.4448 4.33892 16.9479 4.33892C18.4509 4.33892 18.9358 5.66422 18.381 6.4728C19.7349 6.67769 20.5145 8.43177 19.5985 9.3283C21.1236 9.3283 21.6707 11.1724 20.7094 12.0374C21.9707 12.3725 22.5891 14.3249 20.8848 14.9433C19.6705 15.3839 17.5392 16.0126 14.9992 16.5476C15.2492 17.0476 16.0934 19.0614 16.4474 20.3555C16.8954 21.9933 15.2031 23.2071 14.1219 21.997C12.8027 20.5206 11.8213 18.9339 10.3213 17.4339Z",
    fill: "#FEA791"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 5,
    height: 12,
    rx: 1,
    fill: "#E6003E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIconBadOn);
export default __webpack_public_path__ + "static/media/view_icon_bad_on.e717de94a24b3324282bc69d6691c270.svg";
export { ForwardRef as ReactComponent };